var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06899 6.06887L5.66899 2.46887C5.97099 2.16647 6.37299 2.00007 6.80019 2.00007H8.97819C8.70099 1.52367 8.19099 1.20007 7.60019 1.20007H5.20019C4.99539 1.20007 4.79059 1.27807 4.63459 1.43447L1.03459 5.03447C0.722193 5.34687 0.722193 5.85327 1.03459 6.16567L1.65979 6.79087C1.73099 6.52087 1.86619 6.27127 2.06899 6.06887Z",
    fill: "#007BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20005 2.80005H6.80005C6.59525 2.80005 6.39045 2.87805 6.23445 3.03445L2.63445 6.63445C2.32205 6.94685 2.32205 7.45325 2.63445 7.76565L5.83445 10.9656C6.14685 11.278 6.65325 11.278 6.96565 10.9656C7.12205 10.8092 10.4092 7.52205 10.5656 7.36565C10.722 7.20965 10.8 7.00485 10.8 6.80005V4.40005C10.8 3.51645 10.0836 2.80005 9.20005 2.80005ZM9.20005 5.20005C8.75805 5.20005 8.40005 4.84205 8.40005 4.40005C8.40005 3.95805 8.75805 3.60005 9.20005 3.60005C9.64205 3.60005 10 3.95805 10 4.40005C10 4.84205 9.64205 5.20005 9.20005 5.20005Z",
    fill: "#007BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.afc1ee2a327a5145117de532f62a0ee9.svg";
export { ForwardRef as ReactComponent };